import Service from "../Service";
const resource = "FrzAvocadoOil/";

export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "paginate", parameters, {
            params: { requestID: requestID },
        });
    },

    loadsapDemoAvocadoOil(obj, UsrID, requestID) {
        return Service.post('receptionfrozen/' + "loadsapDemoAvocadoOil", obj, {
            params: { UssUserID: UsrID, requestID },
        });
    },
};